import { resolveInputFontSize } from '../TextInputStyles';
import { resolveClearButton } from './resolveClearButton';
import { styledNodeAdornment } from './StyledNodeAdornment';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box } from '../../Box';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const textEndAdornmentStyle = (theme, size, disabled) => ({
  fontSize: resolveInputFontSize(theme, size),
  fontFamily: theme.tokens.ComponentTextInputAdornmentFontFamily,
  fontWeight: theme.tokens.ComponentTextInputAdornmentFontWeight,
  lineHeight: theme.tokens.ComponentTextInputAdornmentLineHeight,
  color: disabled ? theme.tokens.ComponentTextInputDisabledColor : theme.tokens.ComponentTextInputAdornmentColor,
  backgroundColor: disabled ? theme.tokens.ComponentTextInputDisabledBgColor : theme.tokens.ComponentTextInputAdornmentBg
});
export const StyledEndAdornment = _ref => {
  let {
    adornment,
    clearButton,
    onClearButton,
    disabled,
    size,
    adornmentType,
    value
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      flexFlow: 'row',
      justifyContent: 'space-around',
      gap: size === 'small' || size === 'sm' ? '6px' : '8px'
    },
    children: [adornment && (typeof adornment === 'string' ? /*#__PURE__*/_jsx(Box, {
      sx: textEndAdornmentStyle(theme, size, disabled),
      id: 'ids-text-input-adornment-end',
      className: clsx([`ids-text-input-adornment-type-${adornmentType}`]),
      children: adornment
    }) : /*#__PURE__*/_jsx(Box, {
      sx: styledNodeAdornment({
        theme,
        size,
        disabled,
        adornmentType
      }),
      id: 'ids-text-input-adornment-end',
      className: clsx([`ids-text-input-adornment-type-${adornmentType}`]),
      children: adornment
    })), clearButton && value && resolveClearButton(theme, clearButton, Boolean(disabled), size, onClearButton)]
  });
};